<script lang="ts">
  import Card from '@/lib/components/ui/card/card.svelte';
  import DraggableScroll from './DraggableScroll.svelte';
  import { cn } from '@/lib/utils';
  import TrainingCardSquare from './TrainingCardSquare.svelte';
  import type { Exercise } from '@/Common/ActivityFunctions';
  import ExerciseDialog from './ExerciseDialog.svelte';

  export let className = ''; // Optional: allow user to style container
  export let exercises: Exercise[];

  let containerSize: ResizeObserverSize[] | null = null;
  let containerWidth: number | null = null;
  $: if (containerSize && containerSize[0]) containerWidth = containerSize[0].inlineSize;
  let isScrollAtEnd: 'left' | 'scrolling' | 'right' = 'left';

  // Control which dialogs are open
  $: open = exercises?.map(() => false) ?? [];
  let isDragging = false;
  let dragWalk = 0;

  let dialogOpen = false;
  let exerciseForDialog: Exercise | null = null;

</script>

<div class={cn('w-full relative', className)} bind:borderBoxSize={containerSize}>
  <DraggableScroll bind:isDown={isDragging} bind:walk={dragWalk} bind:isScrollAtEnd className="px-4 gap-4">
    {#each exercises.slice(0, 20) as exercise, i (exercise.path)}
      <Card
        class={cn(
          'border-border p-[8px] pt-[12px]',
          isDragging && Math.abs(dragWalk) > 4 ? 'pointer-events-none' : '',
          // Modern hover UI
          'transition-all duration-150 ease-out transform-gpu will-change-transform',
          'hover:shadow-lg hover:-translate-y-0.5 hover:bg-muted',
        )}
        on:click={() => {
          exerciseForDialog = exercise;
          dialogOpen = true;
        }}
      >
        <div class="w-full">
          <TrainingCardSquare size={containerWidth < 600 ? 'sm' : 'lg'} {exercise} />
        </div>
      </Card>
    {/each}
    <ExerciseDialog bind:open={dialogOpen} exercise={exerciseForDialog} />
  </DraggableScroll>
  
  <div class={cn('absolute inset-0 pointer-events-none',
    isScrollAtEnd == 'left' ? 'shadow-[inset_-20px_0_20px_0px_rgba(249,249,249,1)]'
    : isScrollAtEnd == 'right' ? 'shadow-[inset_20px_0_20px_0px_rgba(249,249,249,1)]'
    : 'shadow-[inset_20px_0_20px_0px_rgba(249,249,249,1),inset_-20px_0_20px_0px_rgba(249,249,249,1)]'
  )}>

  </div>
</div>
